// extracted by mini-css-extract-plugin
export default {"header":"header---qaWEI","divider":"divider---ocMje","button":"button---o3IiZ","avatar":"avatar---M20KS","button__label":"button__label---SVT52"};